"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanKey = void 0;
const zod_1 = require("zod");
exports.PlanKey = zod_1.z.string().min(1).brand("PlanKey");
//# sourceMappingURL=plans.js.map